module.exports = __webpack_public_path__ + "static/img/host_activity_lunbo.4affe52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/host_activity/host_activity_lunbo.png
// module id = JLVB
// module chunks = 0